module.exports = __webpack_public_path__ + "img/Logos-EJ-hancook-NB.f7532857.jpg";